import axios from "axios";
import {
  presetHeader,
  requestInterceptor,
  requestErrorInterceptor,
  responseInterceptor,
  errorInterceptor
} from "./systems/httpClientPreset";

axios.defaults.baseURL =
  process.env.NODE_ENV === "production" ? "/" : "http://localhost:1567/";

presetHeader(axios);

axios.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
axios.interceptors.response.use(responseInterceptor, errorInterceptor(axios));

export default axios;
